import React from 'react';
import styled from 'styled-components';

import { MaskBackground, Flex } from './static/style';
import request from '../../request';
import utils from '../../utils';
import FooterShare from '../InvitePoster/components/footerShare';

import '../InvitePoster/css/index.scss';
import './static/css/medal-dialog.scss';

const shareConfig = [{
    key: "friend",
}, {
    key: "timeline",
}, {
    key: "save",
}];

export default class MedalDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentIndex: 0
        };
    }

    componentWillMount() {
        const that = this;

        utils.getAppParams((params) => {
            if (params) {
                that.user = params;
                that.userString = utils.setJsonToUrl(params);
                that.getMedalInfo();
            }
        });
    }

    // 获取勋章数据
    getMedalInfo() {
        request(`/course_v2/situation/encourage_ability`, this.user, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res.code && res.code === 200 && res.data) {
                    this.setState({
                        data: res.data.abilityEncourages ? res.data.abilityEncourages : null,
                        // data: [
                        //     {
                        //         "medalId": 101,
                        //         "medalName": "聪慧小学者",
                        //         "certificateId": 11,
                        //         "certificateUrl": 'https://webres.putaoabc.com/course/images/medal/avatar_101.png',
                        //         "msg": ["小朋友:", "恭喜你成功...."]
                        //     },
                        //     {
                        //         "medalId": null,
                        //         "medalName": "精明小学士",
                        //         "certificateId": 12,
                        //         "certificateUrl": 'https://webres.putaoabc.com/course/images/medal/avatar_101.png',
                        //         "msg": ["小朋友:", "恭喜你成功...."]
                        //     }
                        // ]
                    }, () => {
                        this.requestLookedHandler();   // 显示了就认为看过
                    });
                }
            });
    }

    // 发送看过的请求
    requestLookedHandler() {
        const { data, currentIndex } = this.state;

        if (data && data[currentIndex] && data[currentIndex].certificateId) {
            request(
                `/course_v2/situation/encourage_ability_confirm?${this.userString}&certificateId=${data[currentIndex].certificateId}`,
                Object.assign(
                    {},
                    this.user,
                    { certificateId: data[currentIndex].certificateId }
                ),
                { method: 'POST' }
            )
                .then(res => res.json())
                .then(res => { });
        }
    }

    // 点击关闭（需要切换到下一个勋章）
    clickCloseHandler = () => {
        let { currentIndex } = this.state;

        currentIndex += 1;
        this.setState({
            currentIndex
        }, () => {
            this.requestLookedHandler();    // 显示了就当他看过
        });
    }

    render() {
        const { data, currentIndex } = this.state;

        if (!data || !data[currentIndex]) {
            return null;
        }

        return (
            <MaskBackground opacity='0.7'>
                {/* medal 存在就说明是有头像框的 */}
                {data[currentIndex].medalId
                    ? <MedalContent2>
                        <Picture2 image={data[currentIndex].certificateUrl ? data[currentIndex].certificateUrl : null} />
                        <UserInfo2>
                            <UserMedal>
                                <div>
                                    <div>获得新头像框</div>
                                    <MedalPic image={`https://webres.putaoabc.com/course/images/medal/avatar_${data[currentIndex].medalId}.png`} />
                                </div>
                                <div>
                                    <div>获得新称号</div>
                                    <MedalPic image={`https://webres.putaoabc.com/course/images/medal/medal_${data[currentIndex].medalId}.png`} />
                                </div>
                            </UserMedal>
                            <Text2 dangerouslySetInnerHTML={{ __html: getText(data[currentIndex].msg, true) }} />
                        </UserInfo2>
                        {getShareFooter({ ...this.state })}
                    </MedalContent2>
                    : <MedalContent1>
                        <Picture1 image={data[currentIndex].certificateUrl ? data[currentIndex].certificateUrl : null} />
                        <UserInfo1>
                            <Text>{getText(data[currentIndex].msg, false)}</Text>
                        </UserInfo1>
                        {getShareFooter({ ...this.state })}
                    </MedalContent1>
                }
                <Close onClick={this.clickCloseHandler} />
            </MaskBackground>
        );
    }
}

const getText = (msg, wrap) => {
    let text = '';

    if (msg && Array.isArray(msg)) {
        msg.forEach((value, index) => {
            text += value + (index === 0 && wrap ? '<br />' : '')
        });
    }

    return text;
}

const getShareFooter = ({ data, currentIndex }) => {
    return (
        utils.publicVar.isApp ?
            <div className='invite-poster'>
                <FooterShare
                    shareConfig={shareConfig}
                    posterUrl={data[currentIndex].certificateUrl ? data[currentIndex].certificateUrl : null}
                    landingPageUrl={data[currentIndex].certificateUrl ? data[currentIndex].certificateUrl : null}
                />
            </div>
            : null
    );
}

const MedalBox = styled(Flex)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    background: linear-gradient(#4E1BAA, #7724D1, #8160F3, #6BB3FF);
    border-radius: 0.3rem;
    box-sizing: border-box;
`;

const Picture = styled.div`
    background: url(${props => props.image ? props.image : require('./static/img/dialog/tempPic.png')}) no-repeat center;
    background-size: contain;
`;

const Close = styled.div`
    position: absolute;
    top: 0.37rem;
    right: 0.58rem;
    width: 1rem;
    height: 1rem;
    background: url(${require('./static/img/dialog/close-icon.png')}) no-repeat center;
    background-size: contain;
    cursor: pointer;
`;

const MedalContent1 = styled(MedalBox)`
    width: 14rem;
    min-height: 8.7rem;
    flex-direction: column;
`;

const MedalContent2 = styled(MedalBox)`
    width: 16.73rem;
    min-height: 6.7rem;
    flex-direction: row;
    flex-wrap: wrap;
`;

const Picture1 = styled(Picture)`
    flex: none;
    margin: 0.87rem auto 0.5rem;
    width: 8.7rem;
    height: 6.02rem;
`;

const Picture2 = styled(Picture)`
    margin: 0.57rem 0.14rem 0 0.48rem;
    width: 8rem;
    height: 5.53rem;
`;

const UserInfo1 = styled.div`
    flex: none;
    margin: 0 auto;
    width: 9.5rem;
`;

const UserInfo2 = styled.div`
    width: 7.43rem;
`;

const UserMedal = styled(Flex)`
    margin: 0.51rem 0.52rem 0.26rem 0;
    width: 7.43rem;
    height: 3.53rem;
    border-radius: 0.15rem;
    background: rgba(255,255,255,0.1);
    justify-content: flex-end;

    >div {
        text-align: center;
        color: #fff;
        font-size: 0.3rem;
        height: 100%;
        flex: 1;
        background: url(${require('./static/img/dialog/shine.png')}) no-repeat center;
        background-size: 100%;

        >div {
            margin: 0.38rem 0.4rem;
        }
    }
`;

const MedalPic = styled(Picture)`
    height: 1.84rem;
`;

const Text = styled.div`
    color: #fff;
    font-size: 0.3rem;
    font-weight: 500;
    line-height: 0.4rem;
`;

const Text2 = styled(Text)`
    width: 7.43rem;
    padding: 0.25rem 0.25rem 0.3rem 0.3rem;
    border-radius: 0.15rem;
    background: rgba(255,255,255,0.1);
    font-size: 0.28rem;
    font-weight: 400;
`;



// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/medal-dialog.js